import React from 'react';
import { DescriptionList } from '@printdeal/ui-library';
import { FormattedDate, FormattedMessage } from 'react-intl';
import TimedDeliveryDescription from '../../../../timed-deliveries/TimedDeliveryDescription';

interface DeliveryDateAndTimeProps {
  finalDeliveryDate: string;
  timedDeliveryInfo: {
    before: string;
    after: string;
  }
}

const DeliveryDateAndTime = ({ finalDeliveryDate, timedDeliveryInfo }: DeliveryDateAndTimeProps) => (
  <DescriptionList className="pd-mb-3 md:pd-grid-cols-3">
    <DescriptionList.Title>
      <FormattedMessage
        id="account.order.deliveryDate"
        defaultMessage="Order delivery date"
      />
    </DescriptionList.Title>
    <DescriptionList.Content className="pd-capitalize md:pd-col-span-2">
      <time dateTime={finalDeliveryDate}>
        <FormattedDate
          value={finalDeliveryDate}
          weekday="long"
          day="numeric"
          month="long"
        >
          {(formattedDate: string) => <>{formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)}</>}
        </FormattedDate>
      </time>
      {timedDeliveryInfo && (timedDeliveryInfo.before || timedDeliveryInfo.after) && (
        <>
          {' ('}
          <TimedDeliveryDescription
            before={timedDeliveryInfo.before}
            after={timedDeliveryInfo.after}
          />
          )
        </>
      )}
    </DescriptionList.Content>
  </DescriptionList>
);

export default DeliveryDateAndTime;
